/**
 * 확장된 모의 데이터 - KubeArmor 모든 기능 커버
 * 회사의 KubeArmor 도입 검토를 위한 완전한 대시보드 시연용 데이터
 */

// ============================================================================
// 1. KPI (Key Performance Indicators) 데이터
// ============================================================================

export const kpiData = {
  // 이벤트 통계
  totalEvents: 2847,
  eventsToday: 342,
  blockedEvents: 189,
  allowedEvents: 2658,
  
  // 정책 통계
  totalPolicies: 24,
  activePolicies: 22,
  clusterPolicies: 5,
  hostPolicies: 8,
  podPolicies: 11,
  
  // 보안 점수
  securityScore: 78,
  complianceRate: 85,
  
  // 노드/클러스터
  totalNodes: 12,
  protectedNodes: 11,
  clusterHealth: 92,
  
  // 위협 수준
  criticalAlerts: 3,
  highAlerts: 12,
  mediumAlerts: 34,
  lowAlerts: 89,
};

// ============================================================================
// 2. 정책별 통계 (Pod, Cluster, Host)
// ============================================================================

export const policyStatistics = {
  byType: [
    { name: 'Pod Policies', value: 11, color: '#00d9ff' },
    { name: 'Cluster Policies', value: 5, color: '#ff00ff' },
    { name: 'Host Policies', value: 8, color: '#ffaa00' },
  ],
  
  byStatus: [
    { name: 'Active', value: 22, color: '#00ff00' },
    { name: 'Inactive', value: 1, color: '#808080' },
    { name: 'Testing', value: 1, color: '#ffaa00' },
  ],
  
  byNamespace: [
    { namespace: 'default', count: 5, active: 5 },
    { namespace: 'kube-system', count: 4, active: 4 },
    { namespace: 'production', count: 8, active: 7 },
    { namespace: 'staging', count: 4, active: 3 },
    { namespace: 'development', count: 3, active: 3 },
  ],
};

// ============================================================================
// 3. 이벤트 통계 (Event Type 분류)
// ============================================================================

export const eventTypeStatistics = [
  {
    name: 'Process Events',
    value: 1240,
    percentage: 43.6,
    color: '#00d9ff',
    icon: '▶',
    blocked: 45,
    allowed: 1195,
  },
  {
    name: 'File Access Events',
    value: 890,
    percentage: 31.2,
    color: '#ff00ff',
    icon: '📄',
    blocked: 89,
    allowed: 801,
  },
  {
    name: 'Network Events',
    value: 567,
    percentage: 19.9,
    color: '#ffaa00',
    icon: '🌐',
    blocked: 42,
    allowed: 525,
  },
  {
    name: 'Policy Violation Events',
    value: 150,
    percentage: 5.3,
    color: '#ff3333',
    icon: '⚠️',
    blocked: 13,
    allowed: 137,
  },
];

// ============================================================================
// 4. 심각도별 이벤트 분포
// ============================================================================

export const severityDistribution = [
  { severity: 'Critical', count: 34, events: 3, color: '#ff0000' },
  { severity: 'High', count: 156, events: 12, color: '#ff6600' },
  { severity: 'Medium', count: 892, events: 34, color: '#ffaa00' },
  { severity: 'Low', count: 1765, events: 89, color: '#00ff00' },
];

// ============================================================================
// 5. 시간대별 이벤트 추세 (24시간)
// ============================================================================

export const hourlyEventTrend = [
  { time: '00:00', total: 45, blocked: 3, allowed: 42, severity: 'Low' },
  { time: '01:00', total: 38, blocked: 2, allowed: 36, severity: 'Low' },
  { time: '02:00', total: 52, blocked: 4, allowed: 48, severity: 'Low' },
  { time: '03:00', total: 28, blocked: 1, allowed: 27, severity: 'Low' },
  { time: '04:00', total: 35, blocked: 2, allowed: 33, severity: 'Low' },
  { time: '05:00', total: 62, blocked: 5, allowed: 57, severity: 'Medium' },
  { time: '06:00', total: 89, blocked: 8, allowed: 81, severity: 'Medium' },
  { time: '07:00', total: 145, blocked: 15, allowed: 130, severity: 'High' },
  { time: '08:00', total: 198, blocked: 22, allowed: 176, severity: 'High' },
  { time: '09:00', total: 234, blocked: 28, allowed: 206, severity: 'High' },
  { time: '10:00', total: 167, blocked: 18, allowed: 149, severity: 'Medium' },
  { time: '11:00', total: 156, blocked: 16, allowed: 140, severity: 'Medium' },
  { time: '12:00', total: 142, blocked: 14, allowed: 128, severity: 'Medium' },
  { time: '13:00', total: 156, blocked: 17, allowed: 139, severity: 'Medium' },
  { time: '14:00', total: 189, blocked: 21, allowed: 168, severity: 'High' },
  { time: '15:00', total: 203, blocked: 25, allowed: 178, severity: 'High' },
  { time: '16:00', total: 178, blocked: 19, allowed: 159, severity: 'High' },
  { time: '17:00', total: 165, blocked: 18, allowed: 147, severity: 'Medium' },
  { time: '18:00', total: 142, blocked: 14, allowed: 128, severity: 'Medium' },
  { time: '19:00', total: 123, blocked: 11, allowed: 112, severity: 'Medium' },
  { time: '20:00', total: 98, blocked: 8, allowed: 90, severity: 'Low' },
  { time: '21:00', total: 76, blocked: 6, allowed: 70, severity: 'Low' },
  { time: '22:00', total: 58, blocked: 4, allowed: 54, severity: 'Low' },
  { time: '23:00', total: 42, blocked: 3, allowed: 39, severity: 'Low' },
];

// ============================================================================
// 6. 상위 위협 및 차단된 활동
// ============================================================================

export const topThreats = [
  {
    rank: 1,
    threat: 'Unauthorized Shell Access',
    count: 45,
    severity: 'Critical',
    namespace: 'production',
    pod: 'web-server-pod-1',
    action: 'Blocked',
    policy: 'block-shell-access',
  },
  {
    rank: 2,
    threat: 'Sensitive File Read Attempt',
    count: 38,
    severity: 'High',
    namespace: 'production',
    pod: 'app-server-pod-2',
    action: 'Blocked',
    policy: 'protect-sensitive-files',
  },
  {
    rank: 3,
    threat: 'Unauthorized Process Execution',
    count: 32,
    severity: 'High',
    namespace: 'staging',
    pod: 'test-pod-3',
    action: 'Blocked',
    policy: 'block-unauthorized-exec',
  },
  {
    rank: 4,
    threat: 'Network Lateral Movement',
    count: 28,
    severity: 'High',
    namespace: 'production',
    pod: 'database-pod-1',
    action: 'Blocked',
    policy: 'restrict-network-egress',
  },
  {
    rank: 5,
    threat: 'Write to System Directory',
    count: 24,
    severity: 'Medium',
    namespace: 'default',
    pod: 'backend-pod-4',
    action: 'Blocked',
    policy: 'protect-system-dirs',
  },
];

// ============================================================================
// 7. 노드별 보안 상태
// ============================================================================

export const nodeSecurityStatus = [
  {
    nodeName: 'worker-1',
    status: 'Healthy',
    protectionLevel: 'High',
    activeHosts: 1,
    policies: 8,
    events24h: 245,
    blocked: 23,
  },
  {
    nodeName: 'worker-2',
    status: 'Healthy',
    protectionLevel: 'High',
    activeHosts: 1,
    policies: 8,
    events24h: 267,
    blocked: 28,
  },
  {
    nodeName: 'worker-3',
    status: 'Healthy',
    protectionLevel: 'High',
    activeHosts: 1,
    policies: 7,
    events24h: 198,
    blocked: 19,
  },
  {
    nodeName: 'master-1',
    status: 'Healthy',
    protectionLevel: 'Critical',
    activeHosts: 1,
    policies: 12,
    events24h: 156,
    blocked: 8,
  },
  {
    nodeName: 'master-2',
    status: 'Healthy',
    protectionLevel: 'Critical',
    activeHosts: 1,
    policies: 12,
    events24h: 142,
    blocked: 6,
  },
];

// ============================================================================
// 8. 프로세스 실행 제어 통계
// ============================================================================

export const processControlStats = {
  whitelist: {
    allowed: 1456,
    blocked: 23,
    total: 1479,
    topProcesses: [
      { process: '/usr/bin/curl', count: 234, status: 'Allowed' },
      { process: '/bin/sh', count: 189, status: 'Allowed' },
      { process: '/usr/local/bin/python', count: 167, status: 'Allowed' },
      { process: '/bin/bash', count: 45, status: 'Blocked' },
      { process: '/usr/bin/wget', count: 156, status: 'Allowed' },
    ],
  },
  byType: [
    { type: 'Whitelisted Execution', count: 1456, percentage: 92.1 },
    { type: 'Blacklisted Execution', count: 23, percentage: 1.5 },
    { type: 'Suspicious Execution', count: 98, percentage: 6.4 },
  ],
};

// ============================================================================
// 9. 파일 접근 제어 통계
// ============================================================================

export const fileAccessControlStats = {
  byType: [
    { type: 'Read', count: 456, status: 'Allowed', color: '#00ff00' },
    { type: 'Write', count: 234, status: 'Mixed', color: '#ffaa00' },
    { type: 'Execute', count: 89, status: 'Restricted', color: '#ff6600' },
    { type: 'Delete', count: 34, status: 'Blocked', color: '#ff0000' },
  ],
  protectedPaths: [
    { path: '/etc/passwd', attempts: 45, blocked: 45 },
    { path: '/etc/shadow', attempts: 23, blocked: 23 },
    { path: '/root/.ssh', attempts: 12, blocked: 12 },
    { path: '/proc/sys', attempts: 67, blocked: 34 },
    { path: '/sys/kernel', attempts: 34, blocked: 28 },
  ],
};

// ============================================================================
// 10. 네트워크 제어 통계
// ============================================================================

export const networkControlStats = {
  inbound: {
    allowed: 678,
    blocked: 45,
    total: 723,
  },
  outbound: {
    allowed: 523,
    blocked: 67,
    total: 590,
  },
  byProtocol: [
    { protocol: 'TCP', count: 892, allowed: 834, blocked: 58 },
    { protocol: 'UDP', count: 234, allowed: 198, blocked: 36 },
    { protocol: 'ICMP', count: 156, allowed: 145, blocked: 11 },
  ],
  topConnections: [
    { src: '10.0.1.5:8080', dst: '10.0.2.10:443', protocol: 'TCP', status: 'Allowed', count: 456 },
    { src: '10.0.1.6:3000', dst: '10.0.2.20:5432', protocol: 'TCP', status: 'Allowed', count: 378 },
    { src: '10.0.1.7:9090', dst: '8.8.8.8:53', protocol: 'UDP', status: 'Blocked', count: 45 },
    { src: '10.0.1.8:9999', dst: '192.168.1.1:1234', protocol: 'TCP', status: 'Blocked', count: 32 },
  ],
};

// ============================================================================
// 11. 컴플라이언스 및 감사 데이터
// ============================================================================

export const complianceData = {
  overall: 85,
  byFramework: [
    { framework: 'CIS Kubernetes', compliance: 88, color: '#00ff00' },
    { framework: 'NIST', compliance: 82, color: '#ffaa00' },
    { framework: 'PCI-DSS', compliance: 79, color: '#ff6600' },
    { framework: 'SOC 2', compliance: 91, color: '#00ff00' },
  ],
  policyAudit: [
    { event: 'Policy Created', timestamp: '2026-01-25 14:32', user: 'admin', status: 'Success' },
    { event: 'Policy Modified', timestamp: '2026-01-25 13:45', user: 'security-team', status: 'Success' },
    { event: 'Policy Deleted', timestamp: '2026-01-24 16:20', user: 'admin', status: 'Success' },
    { event: 'Policy Enforced', timestamp: '2026-01-24 10:15', user: 'system', status: 'Success' },
  ],
};

// ============================================================================
// 12. 정책 효과성 분석
// ============================================================================

export const policyEffectiveness = [
  {
    policyName: 'block-shell-access',
    attempts: 456,
    blocked: 423,
    effectiveness: 92.8,
    severity: 'Critical',
  },
  {
    policyName: 'protect-sensitive-files',
    attempts: 234,
    blocked: 201,
    effectiveness: 85.9,
    severity: 'High',
  },
  {
    policyName: 'restrict-network-egress',
    attempts: 189,
    blocked: 168,
    effectiveness: 88.9,
    severity: 'High',
  },
  {
    policyName: 'block-unauthorized-exec',
    attempts: 145,
    blocked: 134,
    effectiveness: 92.4,
    severity: 'High',
  },
  {
    policyName: 'protect-system-dirs',
    attempts: 98,
    blocked: 87,
    effectiveness: 88.8,
    severity: 'Medium',
  },
];

// ============================================================================
// 13. 일일 변화 추이 (지난 7일)
// ============================================================================

export const weeklyTrend = [
  { date: 'Jan 19', events: 1240, blocked: 78, threats: 8, policies: 22 },
  { date: 'Jan 20', events: 1456, blocked: 95, threats: 12, policies: 22 },
  { date: 'Jan 21', events: 1876, blocked: 134, threats: 18, policies: 23 },
  { date: 'Jan 22', events: 2145, blocked: 156, threats: 24, policies: 23 },
  { date: 'Jan 23', events: 2456, blocked: 178, threats: 28, policies: 24 },
  { date: 'Jan 24', events: 2678, blocked: 189, threats: 31, policies: 24 },
  { date: 'Jan 25', events: 2847, blocked: 189, threats: 34, policies: 24 },
];

// ============================================================================
// 14. 클러스터 건강 상태
// ============================================================================

export const clusterHealth = {
  score: 92,
  components: [
    { component: 'Policy Enforcement', status: 'Healthy', percentage: 95 },
    { component: 'Event Processing', status: 'Healthy', percentage: 98 },
    { component: 'Network Monitoring', status: 'Healthy', percentage: 89 },
    { component: 'File System Monitoring', status: 'Healthy', percentage: 91 },
    { component: 'Host Security', status: 'Healthy', percentage: 87 },
    { component: 'Policy Audit', status: 'Healthy', percentage: 99 },
  ],
};

// ============================================================================
// 15. 성능 메트릭
// ============================================================================

export const performanceMetrics = {
  eventProcessingLatency: {
    p50: 12,     // milliseconds
    p95: 45,
    p99: 89,
    avg: 24,
  },
  policyEnforcementTime: {
    p50: 5,
    p95: 18,
    p99: 42,
    avg: 11,
  },
  systemResourceUsage: {
    cpuUsage: 8.5,        // percentage
    memoryUsage: 34.2,    // percentage
    diskIO: 12.1,         // percentage
  },
};

// ============================================================================
// 16. 위협 인텔리전스 요약
// ============================================================================

export const threatIntelligence = {
  recentDetections: [
    {
      id: 'TI-001',
      name: 'Privilege Escalation Attempt',
      detectedTime: '2026-01-25 15:42',
      severity: 'Critical',
      cveIds: ['CVE-2025-1234', 'CVE-2025-5678'],
      mitreTechnique: 'T1548 - Abuse Elevation Control Mechanism',
      blocked: true,
    },
    {
      id: 'TI-002',
      name: 'Data Exfiltration Pattern',
      detectedTime: '2026-01-25 14:28',
      severity: 'High',
      cveIds: [],
      mitreTechnique: 'T1041 - Exfiltration Over C2 Channel',
      blocked: true,
    },
    {
      id: 'TI-003',
      name: 'Suspicious Container Escape',
      detectedTime: '2026-01-25 13:15',
      severity: 'Critical',
      cveIds: ['CVE-2025-9101'],
      mitreTechnique: 'T1611 - Escape to Host',
      blocked: true,
    },
  ],
  mitreCoverage: 88,  // percentage
};

// ============================================================================
// 17. 리소스별 보안 상태
// ============================================================================

export const resourceSecurityStatus = [
  {
    resource: 'web-app-deployment',
    type: 'Deployment',
    namespace: 'production',
    protectedPods: 3,
    totalPods: 3,
    policiesApplied: 5,
    recentEvents: 145,
    threatLevel: 'Low',
  },
  {
    resource: 'database-statefulset',
    type: 'StatefulSet',
    namespace: 'production',
    protectedPods: 2,
    totalPods: 2,
    policiesApplied: 8,
    recentEvents: 89,
    threatLevel: 'Low',
  },
  {
    resource: 'cache-redis',
    type: 'Pod',
    namespace: 'production',
    protectedPods: 1,
    totalPods: 1,
    policiesApplied: 4,
    recentEvents: 56,
    threatLevel: 'Low',
  },
  {
    resource: 'api-gateway-ingress',
    type: 'Deployment',
    namespace: 'staging',
    protectedPods: 2,
    totalPods: 2,
    policiesApplied: 6,
    recentEvents: 234,
    threatLevel: 'Medium',
  },
];

// ============================================================================
// 18. 정책 템플릿 및 권장사항
// ============================================================================

export const policyRecommendations = [
  {
    id: 'RECOMMEND-001',
    title: 'Enable DNS Monitoring Policy',
    description: 'Add DNS request monitoring to detect DNS tunneling attacks',
    framework: 'MITRE ATT&CK',
    severity: 'High',
    estimatedImpact: 'Detects data exfiltration via DNS',
  },
  {
    id: 'RECOMMEND-002',
    title: 'Implement Privileged Container Detection',
    description: 'Block or monitor privileged container creation',
    framework: 'CIS Kubernetes',
    severity: 'Critical',
    estimatedImpact: 'Prevents container breakout attacks',
  },
  {
    id: 'RECOMMEND-003',
    title: 'Add System Call Monitoring',
    description: 'Enable deep system call profiling for advanced threat detection',
    framework: 'Runtime Security',
    severity: 'Medium',
    estimatedImpact: 'Detects low-level kernel exploits',
  },
];

// ============================================================================
// 19. 노드 데이터 (Node Data)
// ============================================================================

export const nodeData = [
  {
    name: 'worker-node-01',
    ip: '10.0.1.11',
    threats: 2,
    protected: true,
    policies: 5,
    status: 'Healthy',
  },
  {
    name: 'worker-node-02',
    ip: '10.0.1.12',
    threats: 1,
    protected: true,
    policies: 5,
    status: 'Healthy',
  },
  {
    name: 'control-plane-01',
    ip: '10.0.0.10',
    threats: 3,
    protected: true,
    policies: 8,
    status: 'Healthy',
  },
  {
    name: 'worker-node-03',
    ip: '10.0.1.13',
    threats: 0,
    protected: true,
    policies: 5,
    status: 'Healthy',
  },
  {
    name: 'edge-node-01',
    ip: '10.0.2.20',
    threats: 5,
    protected: false,
    policies: 2,
    status: 'Warning',
  },
];
